import { Capacitor } from '@capacitor/core';
import { canOfferAppleSignIn } from './appleAuthAvailability';

/**
 * Web browsers (including Safari): Google sign-in only — no Apple button (Apple web sign-in was unreliable).
 * Web Google uses popup. Native iPhone app (Capacitor): Sign in with Apple plus Google (Apple is primary in UI).
 */
export const AUTH_WEB_GOOGLE_ONLY = true;

/** @deprecated Use AUTH_WEB_GOOGLE_ONLY */
export const AUTH_SIGN_IN_GOOGLE_ONLY = AUTH_WEB_GOOGLE_ONLY;

/** Sign-in gate + Settings: show Apple where the platform supports it, except pure web when AUTH_WEB_GOOGLE_ONLY. */
export const shouldShowAppleSignInUi = () => {
  if (!canOfferAppleSignIn()) return false;
  if (AUTH_WEB_GOOGLE_ONLY && !Capacitor.isNativePlatform()) return false;
  return true;
};

/** Post-login “link Apple” prompt: same rule — not on web when web is Google-only. */
export const shouldOfferLinkAppleNudge = () => shouldShowAppleSignInUi();
